/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MediumModal from '../../../../atoms/Modal/MediumModal';
import { QuestionCreationFinalCall, QuestionCreationScreenCancel } from '../../../../../redux/action';
import McqSingleAnswer from './QuestionType.js/MCQ-singleAnswer';
import McqMultiAnswer from './QuestionType.js/MCQ-multiAnswer';
import TitaQuestions from './QuestionType.js/TITA';
import TitaSpecificRange from './QuestionType.js/TITA-specificRange';
import TitaSpecificFormat from './QuestionType.js/TITA-specificFormat';
import GraphAnalysis from './QuestionType.js/GraphAnalysis';
import { CallWithAuth } from '../../../../../action/apiActions';
import { GET_QUESTIOB_TYPE } from '../../../../../action/apiPath';
import { useLocation, useNavigate } from 'react-router-dom';
import style from '../../../../../assets/styles/createQuestion.module.css';
import QuillEditor from '../../../../atoms/QuillEditor';
import DescriptveText from './QuestionType.js/Descriptive';
import HighlightCorrectSentence from './QuestionType.js/HighlightCorrectSentence';
import FractionInput from './QuestionType.js/FractionInput';
import FractionDecimalInput from './QuestionType.js/FractionDecimalInput';
import SelectionPerRowInline from './QuestionType.js/SelectionPerRowInline';
import SelectionPerRowLabel from './QuestionType.js/SelectionPerRowLabel';
import SelectionPerColumn from './QuestionType.js/SelectionPerColumn';
import MultiSource from './MultiSource';
import arrowIcon from '../../../../../assets/images/upArrow.svg';
interface CreatingQuestionGroupedProps {
  id: string | number;
  getData: any; // Replace 'any' with the appropriate type if known
}

const CreatingQuestionGrouped: React.FC<CreatingQuestionGroupedProps> = ({ id, getData }) => {
  // _______ initialization:start _______
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // _______ initialization: end _______
  //_______ redux selector _______
  const basicInfo = useSelector((state: any) => state.BasicInformationReducer);
  // MODAL OPEN AND CLOSE
  const [modalMedium, setModalMedium] = useState(false);
  const [modalData] = useState({
    title: 'Requires a Review',
    description: 'The question needs to be reviewed by our team before adding it to the Question Bank',
    cancelButton: 'Continue Editing',
    saveButton: 'Send for Review',
  });
  const location = useLocation();
  const questionAuthoringTaskId = Number(location.state?.queTaskId);
  const editTaskId = location?.state;
  const [taskLabel, setTaskLabel] = useState<number | null>(null);
  const [editTaskLabel, setEditTaskLabel] = useState<number | null>(null);
  useEffect(() => {
    if (questionAuthoringTaskId) {
      setTaskLabel(questionAuthoringTaskId);
    } else if (editTaskId && editTaskId != undefined && editTaskId !== null) {
      setTimeout(() => {
        if (getData?.length > 0 && getData[0]?.edit_task_label) {
          setEditTaskLabel(getData[0]?.edit_task_label);
        }
        if (getData?.length > 0 && getData[0]?.task_label) {
          setTaskLabel(getData[0]?.task_label);
        } else {
          setTaskLabel(Number(editTaskId));
        }
      }, 0);
    } else if (getData?.length > 0 && getData[0]?.edit_task_label) {
      setEditTaskLabel(getData[0]?.edit_task_label);
    } else if (basicInfo?.task_label) {
      setTaskLabel(basicInfo?.task_label);
    }
    console.log(taskLabel, editTaskLabel);
  }, []);
  const openModalMedium = () => {
    setModalMedium(true);
  };

  const closeModalMedium = () => {
    setModalMedium(false);
  };

  const [passage_text, setPassage_text] = useState<string | null>(null);
  const [atext, setAtext] = useState<boolean>(false);
  const editorRef = useRef<any>(null);
  const setRef = (data: any) => {
    editorRef.current = data;
  };
  const [bodyformultiquestion, setBodyformultiquestion] = useState([
    {
      idx: 0,
      question_type_id: basicInfo.question_group[0].question_type_id,
      question_short_identifier: Array.isArray(getData) ? getData[0]?.question_short_identifier || null : null,
      compose_question: Array.isArray(getData) ? getData[0]?.compose_question || null : null,
      options: Array.isArray(getData) ? getData[0]?.options || null : null,
      correct_answer: Array.isArray(getData) ? getData[0]?.correct_answer || null : null,
      last_option_idx: Array.isArray(getData) ? getData[0]?.last_option_idx || null : null,
      randomise_answers: Array.isArray(getData) ? getData[0]?.randomise_answers || false : false,
      explaination_video: Array.isArray(getData) ? getData[0]?.explaination_video || null : null,
      explaination_text: Array.isArray(getData) ? getData[0]?.explaination_text || null : null,
      answer_format: Array.isArray(getData) ? getData[0]?.answer_format : null,
      task_label: Array.isArray(getData) ? getData[0]?.task_label : null,
      edit_task_label: Array.isArray(getData) ? getData[0]?.edit_task_label : null,
      question_direction: Array.isArray(getData) ? getData[0]?.question_direction || null : null,
      video_id: Array.isArray(getData) ? getData[0]?.video_id || null : null,
    },
  ]);

  interface FinalBody {
    question_group: typeof bodyformultiquestion;
    passage?: string | null;
    multi_source_type?: any;
    passages?: any[];
    tables?: any[];
    multi_source_text?: any;
  }

  const [finalbody, setFinalbody] = useState<FinalBody | null>(null);
  const [question, setQuestion] = useState([0]);
  const [questionbutton, setQuestionbutton] = useState(0);
  const [passage, setPassage] = useState<any[]>([]);
  const [passageButton, setPassageButton] = useState<number>(0);
  const [sourceText, setSourceText] = useState<string | undefined>('');
  const [sourceTable, setSourceTable] = useState<any[]>([]);
  const [sourceTableButton, setSourceTableButton] = useState<number>(0);
  const [sourceTableText, setSourceTableText] = useState<string | undefined>('');
  const [selectedType, setSelectedType] = useState<number>(1);
  const params = location.pathname;
  const isEdit = params?.includes('edit');
  // ________ get category from API and grouped in sequence ________
  const [questionCategory, setQuestionCategory] = useState([]);
  const GetQuestionTypeCategory = async () => {
    const category = await CallWithAuth('GET', GET_QUESTIOB_TYPE);
    if (category.status && category.res && category.res.status === 200) {
      setQuestionCategory(category.res.data);
    }
  };

  useEffect(() => {
    GetQuestionTypeCategory();
  }, []);

  function transalte(str: string) {
    const sentence = decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sentence;

    // Function to check if a string contains only spaces, `&nbsp;`, or is empty
    const isEmptyText = (text: any) => {
      const trimmedText = text.replace(/&nbsp;/g, '').trim();
      return trimmedText.length === 0;
    };

    // Check if there are <p> tags and process them
    const pTags = tempDiv.querySelectorAll('p');
    if (pTags.length > 0) {
      const hasNonEmptyPTag = Array.from(pTags).some((p) => !isEmptyText(p.innerHTML));
      return hasNonEmptyPTag ? str : '';
    } else {
      // If no <p> tags, check if the entire input has any meaningful content
      const textContent = tempDiv?.textContent?.trim();
      return textContent && textContent.length > 0 ? str : '';
    }
  }
  const saveAndContinue = () => {
    const payload = { ...finalbody };
    payload.passage = payload.passage && transalte(payload.passage);
    payload.question_group = payload?.question_group?.map((items: any, index: any) => {
      if (questionAuthoringTaskId) {
        items.task_label = questionAuthoringTaskId;
        items.edit_task_label = basicInfo?.question_group[index]?.edit_task_label ?? null;
      } else if (basicInfo?.question_group.length > 0) {
        items.task_label = basicInfo?.question_group[index]?.task_label;
        items.edit_task_label = basicInfo?.question_group[index]?.edit_task_label ?? null;
      }
      items.compose_question = items.compose_question && transalte(items.compose_question);
      items.explaination_text = items.explaination_text && transalte(items.explaination_text);
      if (getData?.[0]?.group_uuid) {
        items.group_uuid = getData?.[0]?.group_uuid ?? null;
      }
      return items;
    });
    if (payload.multi_source_type === 2 && payload.passages) {
      payload.passages?.map((items: any) => {
        items.desc = items.desc ? transalte(items.desc) : undefined;
        items.name = items.name?.trim();
        return items;
      });
    }
    if (payload.multi_source_type === 3 && payload.tables) {
      payload?.tables?.map((items: any) => {
        items.desc = items.desc ? transalte(items.desc) : undefined;
        items.name = items.name?.trim();
        return items;
      });
    }
    dispatch(QuestionCreationFinalCall(payload, id));
  };

  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const Permission: any = JSON.parse(sessionStorage.getItem('questionAccess') ?? '{}');
  const [highLightData, setHighLightData] = useState<string>('');
  const SetSelectQuestionType = (e: any) => {
    const updatebody = [...bodyformultiquestion];
    updatebody[questionbutton] = {
      idx: questionbutton,
      question_type_id: e,
      question_short_identifier: null,
      compose_question: null,
      options: null,
      correct_answer: null,
      last_option_idx: null,
      randomise_answers: false,
      explaination_video: null,
      explaination_text: null,
      answer_format: null,
      question_direction: null,
      // "difficulty": basicInfo.difficulty,
      // "question_type": e,
      // "format": basicInfo.format,
      task_label: null,
      edit_task_label: null,
      video_id: null,
    };
    setBodyformultiquestion(updatebody);
  };

  useEffect(() => {
    if (selectedType === 2) {
      setFinalbody({
        question_group: bodyformultiquestion,
        multi_source_type: selectedType,
        passages: passage,
        multi_source_text: sourceText,
      });
    } else if (selectedType === 3) {
      setFinalbody({
        question_group: bodyformultiquestion,
        multi_source_type: selectedType,
        tables: sourceTable,
        multi_source_text: sourceTableText,
      });
    } else {
      setFinalbody({
        question_group: bodyformultiquestion,
        passage: passage_text,
        multi_source_type: selectedType,
      });
    }
  }, [bodyformultiquestion, passage_text, selectedType, passage, sourceText, sourceTable, sourceTableText]);

  // drag practice

  const draggables = document.querySelectorAll('.draggable');
  const containers = document.querySelectorAll('.container');

  draggables.forEach((draggable) => {
    draggable.addEventListener('dragstart', () => {
      draggable.classList.add('dragging');
    });

    draggable.addEventListener('dragend', () => {
      draggable.classList.remove('dragging');
    });
  });

  containers.forEach((container: any) => {
    container.addEventListener('dragover', (e: any) => {
      e.preventDefault();
      const afterElement = getDragAfterElement(container, e.clientY);
      const draggable = document.querySelector('.dragging');
      if (afterElement === null) {
        if (draggable) {
          container.appendChild(draggable);
        }
      } else {
        container.insertBefore(draggable, afterElement);
      }
    });
  });
  useEffect(() => {
    const generateBodyForMultiQuestion = () => {
      return basicInfo.question_group.map((question: any, index: any) => ({
        idx: index,
        question_type_id: question.question_type_id,
        question_short_identifier: Array.isArray(getData) ? getData[index]?.question_short_identifier || null : null,
        compose_question: Array.isArray(getData) ? getData[index]?.compose_question || null : null,
        options: Array.isArray(getData) ? getData[index]?.options || null : null,
        correct_answer: Array.isArray(getData) ? getData[index]?.correct_answer || null : null,
        last_option_idx: Array.isArray(getData) ? getData[index]?.last_option_idx || null : null,
        randomise_answers: Array.isArray(getData) ? getData[index]?.randomise_answers || false : false,
        explaination_video: Array.isArray(getData) ? getData[index]?.explaination_video || null : null,
        explaination_text: Array.isArray(getData) ? getData[index]?.explaination_text || null : null,
        answer_format: Array.isArray(getData) ? getData[index]?.answer_format : null,
        task_label: Array.isArray(getData) ? getData[index]?.task_label : null,
        edit_task_label: Array.isArray(getData) ? getData[index]?.edit_task_label : null,
        question_direction: Array.isArray(getData) ? getData[index]?.question_direction || null : null,
        video_id: Array.isArray(getData) ? getData[index]?.video_id || null : null,
      }));
    };
    const generateQuestionArray = () => {
      return Array.from({ length: basicInfo.question_group.length }, (_, index) => index);
    };

    // Update the state
    setPassage_text(Array.isArray(getData) ? getData[0]?.passage : '');
    setSelectedType(Array.isArray(getData) && getData[0]?.multi_source_type ? getData[0]?.multi_source_type : 1);
    setSourceText(Array.isArray(getData) ? getData[0]?.multi_source_text : '');
    setPassage(Array.isArray(getData) ? getData[0]?.passages : []);
    setSourceTableText(Array.isArray(getData) ? getData[0]?.multi_source_text : '');
    setSourceTable(Array.isArray(getData) ? getData[0]?.tables : []);
    setQuestion(generateQuestionArray());
    setBodyformultiquestion(generateBodyForMultiQuestion());
    if (isEdit) setShowModal(true);
    if (isEdit && getData[0]?.question_type_id?.id === 16)
      setHighLightData(
        Array.isArray(getData) ? b64DecodeUnicode(getData[0]?.passage).replace(/<\/?[\w\s="/':;#.-]+>/g, '') : ''
      );
  }, [basicInfo]);

  function getDragAfterElement(container: any, y: any) {
    const draggableElements = [...container.querySelectorAll('.draggable:not(.dragging)')];

    return draggableElements.reduce(
      (closest, child) => {
        const box = child.getBoundingClientRect();
        const offset = y - box.top - box.height / 2;
        if (offset < 0 && offset > closest.offset) {
          return { offset: offset, element: child };
        } else {
          return closest;
        }
      },
      { offset: Number.NEGATIVE_INFINITY }
    ).element;
  }

  // _____________ MODAL OPEN AND CLOSE _____________
  const [modalMediumCancel, setModalMediumCancel] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [modalDataCancel] = useState({
    title: 'Are you sure, Do you want to cancel Question Creation?',
    description: 'Your Current Changes Will Not Be Saved And You Will Be Redirected To Question Listing ',
    cancelButton: 'Continue Editing',
    saveButton: 'Yes, Cancel',
  });

  const openModalMediumCancel = () => {
    setModalMediumCancel(true);
  };

  const closeModalMediumCancel = () => {
    setModalMediumCancel(false);
  };

  // cancel button to send the user to question-bank
  const Cancel = () => {
    navigate('/question-bank');
    dispatch(QuestionCreationScreenCancel());
  };

  function b64DecodeUnicode(str: string) {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }

  function convertToBase64(str: string) {
    return btoa(unescape(encodeURIComponent(str)));
  }

  const handleOutsideClick = (event: any) => {
    if (event?.target?.id === 'modelClick') {
      return;
    }
    if (!showModal && atext && editorRef?.current && !editorRef?.current?.container?.contains(event?.target)) {
      setHighLightData(editorRef?.current?.getContent({ format: 'text' }));
    }
  };

  useEffect(() => {
    // Attach event listener for clicks on the document
    document.addEventListener('click', handleOutsideClick);

    return () => {
      // Cleanup event listener on component unmount
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [atext]);

  return (
    <>
      <MultiSource
        passage={passage}
        setPassage={setPassage}
        passageButton={passageButton}
        setPassageButton={setPassageButton}
        setSourceText={setSourceText}
        sourceText={sourceText}
        sourceTable={sourceTable}
        setSourceTable={setSourceTable}
        sourceTableButton={sourceTableButton}
        setSourceTableButton={setSourceTableButton}
        sourceTableText={sourceTableText}
        setSourceTableText={setSourceTableText}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        isEdit={isEdit}
        queTypeId={bodyformultiquestion[questionbutton]?.question_type_id}
      />
      {(bodyformultiquestion[questionbutton]?.question_type_id === 6 ||
        bodyformultiquestion[questionbutton]?.question_type_id === 14 ||
        bodyformultiquestion[questionbutton]?.question_type_id === 15 ||
        bodyformultiquestion[questionbutton]?.question_type_id === 16 ||
        bodyformultiquestion[questionbutton]?.question_type_id === 17 ||
        bodyformultiquestion[questionbutton]?.question_type_id === 18 ||
        bodyformultiquestion[questionbutton]?.question_type_id === 19 ||
        bodyformultiquestion[questionbutton]?.question_type_id === 20 ||
        bodyformultiquestion[questionbutton]?.question_type_id === 21) && (
        <div style={{ position: 'relative' }}>
          <select
            name="question"
            id="question"
            disabled={getData}
            style={{ appearance: 'none' }}
            className={` ${style.question_creating} ${style.pointer} ${style.selectdropdown}`}
            onClick={(e: any) => {
              SetSelectQuestionType(JSON.parse(e.target.value).id);
            }}
          >
            {/* <option value={JSON.stringify(questionCategory.filter((items,i)=>items.id===bodyformultiquestion[questionbutton].question_type_id).map((item,i)=>(item)))} hidden > - {questionCategory.filter((items,i)=>items.id===bodyformultiquestion[questionbutton].question_type_id).map((item,i)=>(item.name))}</option> */}
            {questionCategory.map((items: any) => (
              <option
                key={items.name}
                value={JSON.stringify(items)}
                selected={bodyformultiquestion[questionbutton]?.question_type_id === items.id}
              >
                {`${items.name}`}
              </option>
            ))}
          </select>
          <img src={arrowIcon} alt="Custom Arrow" className={style.dropdownSelectArrow} />
        </div>
      )}
      {/* add passage/text with tnymce*/}
      {selectedType === 1 && (
        <div>
          <div className={style.passage_text}>
            <p>
              Add Passage/Text <b className={style.red_mendantory}>*</b>
            </p>

            <div style={{ height: 'auto', flexGrow: '1' }}>
              <QuillEditor
                refSetter={(data: any) => setRef(data)}
                ref={editorRef}
                setA={setAtext}
                id={16}
                toolbarList={
                  bodyformultiquestion[questionbutton]?.question_type_id === 14 ||
                  bodyformultiquestion[questionbutton]?.question_type_id === 15
                }
                setShowModal={setShowModal}
                onBlurChange={handleOutsideClick}
                defaultValue={passage_text !== null ? b64DecodeUnicode(passage_text) : ''}
                onChange={(content: string) => setPassage_text(convertToBase64(content))}
              />
            </div>
          </div>
          <span className={style.seprator}></span>
        </div>
      )}

      <div
        className={`${style.container} ${style.questionContainer}`}
        style={{ width: '100%', overflowX: question.length >= 5 ? 'scroll' : 'hidden' }}
      >
        {question?.map((items, i) => (
          <button
            key={items}
            draggable="true"
            className={
              items === questionbutton
                ? ` ${style.multiquestionbutton} ${style.draggable}`
                : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
            }
            onClick={() => setQuestionbutton(i)}
          >
            {items === questionbutton ? (
              <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                  fill="white"
                />
              </svg>
            ) : (
              <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                  fill="#272727"
                />
              </svg>
            )}{' '}
            <span style={{ width: '115px' }}>&nbsp; Question {i + 1}</span>
          </button>
        ))}
      </div>

      {/* question type getting from screen 2.1 and dropdown for changing for question*/}

      {bodyformultiquestion[questionbutton]?.question_type_id !== 6 &&
        bodyformultiquestion[questionbutton]?.question_type_id !== 14 &&
        bodyformultiquestion[questionbutton]?.question_type_id !== 15 &&
        bodyformultiquestion[questionbutton]?.question_type_id !== 16 &&
        bodyformultiquestion[questionbutton]?.question_type_id !== 17 &&
        bodyformultiquestion[questionbutton]?.question_type_id !== 18 &&
        bodyformultiquestion[questionbutton]?.question_type_id !== 19 &&
        bodyformultiquestion[questionbutton]?.question_type_id !== 20 && (
          <div style={{ position: 'relative' }}>
            <select
              name="question"
              id="question"
              disabled={getData}
              style={{ appearance: 'none' }}
              className={` ${style.question_creating} ${style.pointer}`}
              onClick={(e: any) => SetSelectQuestionType(JSON.parse(e.target.value).id)}
            >
              {questionCategory.map((items: any) => (
                <option
                  key={items.name}
                  value={JSON.stringify(items)}
                  selected={bodyformultiquestion[questionbutton]?.question_type_id === items.id}
                >
                  {`${items.name}`}
                </option>
              ))}
            </select>
            <img src={arrowIcon} alt="Custom Arrow" className={style.dropdownSelectArrow} />
          </div>
        )}

      {/*_______  QUESTION TYPE SCREEN ACCORDING TO SELECTOR _______  */}
      {bodyformultiquestion[questionbutton]?.question_type_id === 1 ? (
        <McqSingleAnswer
          key={questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 2 ? (
        <McqMultiAnswer
          key={questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 3 ? (
        <TitaQuestions
          key={questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 4 ? (
        <TitaSpecificRange
          key={questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 5 ? (
        <TitaSpecificFormat
          key={questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 6 ? (
        <DescriptveText
          key={bodyformultiquestion[questionbutton]?.question_type_id + questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 14 ||
      bodyformultiquestion[questionbutton]?.question_type_id === 15 ? (
        <GraphAnalysis
          key={bodyformultiquestion[questionbutton]?.question_type_id + questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 16 ? (
        <HighlightCorrectSentence
          setShowModal={(t) => setShowModal(t)}
          editor={editorRef?.current}
          showModal={showModal}
          passageText={() => editorRef?.current?.getContent({ format: 'text' })}
          data={highLightData}
          key={bodyformultiquestion[questionbutton]?.question_type_id + questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 17 ? (
        <SelectionPerRowInline
          key={bodyformultiquestion[questionbutton]?.question_type_id + questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 18 ? (
        <SelectionPerRowLabel
          key={bodyformultiquestion[questionbutton]?.question_type_id + questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 19 ? (
        <SelectionPerColumn
          key={bodyformultiquestion[questionbutton]?.question_type_id + questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 20 ? (
        <FractionInput
          key={bodyformultiquestion[questionbutton]?.question_type_id + questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {bodyformultiquestion[questionbutton]?.question_type_id === 21 ? (
        <FractionDecimalInput
          key={bodyformultiquestion[questionbutton]?.question_type_id + questionbutton}
          body={bodyformultiquestion}
          questionbutton={questionbutton}
          setbodyformultiquestion={setBodyformultiquestion}
        />
      ) : (
        ''
      )}
      {/* SAVE AND CONTINUE  */}
      <div className={`${style.saveButton_questionCreation} ${style.publishButton}`}>
        <button
          className={` ${style.cancel} ${style.pointer} ${style.cancelBtnWrap}`}
          onClick={() => openModalMediumCancel()}
        >
          Cancel
        </button>
        <div>
          <button
            className={style.blue_button}
            onClick={() => (Permission.edit || Permission.review ? saveAndContinue() : openModalMedium())}
          >
            {Permission.edit || Permission.review ? 'Publish' : 'Save & Continue'}
          </button>
        </div>
      </div>
      {/* SAVE AND CONTINUE  */}

      {/* MEDIUM MODAL CALL with dispatch function  */}
      <MediumModal
        modalData={modalData}
        forwardButton={() => saveAndContinue()}
        modalMedium={modalMedium}
        closeModalMedium={closeModalMedium}
      />
      {/* dispatch(QuestionCreationFinalCall(finalbody, id)) */}

      <MediumModal
        modalMedium={modalMediumCancel}
        forwardButton={() => Cancel()}
        closeModalMedium={closeModalMediumCancel}
        modalData={modalDataCancel}
      />
    </>
  );
};

export default CreatingQuestionGrouped;
